import logger from './logger';

export default {
    /**
     * Handles exception when calling window.localStorage.setItem
     * An exception will happen when Safari is used in private mode, because the localStorage quota is zero
     *
     * @param {String} keyName
     * @param {String} keyValue
     * @returns {Boolean} The return value indicates if the localStorage item could be set or not.
     */
    setItem: function (keyName, keyValue) {
        let valueIsSet;

        try {
            window.localStorage.setItem(keyName, keyValue);
            valueIsSet = true;
        } catch (e) {
            let msg = 'Failed to set key "' + keyName + '" with value "' + keyValue + '" to localStorage.';
            msg += ' Exception was thrown: ' + e;
            logger.warn(msg);
            valueIsSet = false;
        }

        return valueIsSet;
    },
    getItem: function (keyName) {
        return window.localStorage.getItem(keyName);
    },
    removeItem: function (keyName) {
        window.localStorage.removeItem(keyName);
    },
    clear: function () {
        window.localStorage.clear();
    },
};
